import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=9b60d1a8&"
import script from "./barcode.vue?vue&type=script&lang=js&"
export * from "./barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmtkpv/Projects/barcode-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9b60d1a8', component.options)
    } else {
      api.reload('9b60d1a8', component.options)
    }
    module.hot.accept("./barcode.vue?vue&type=template&id=9b60d1a8&", function () {
      api.rerender('9b60d1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/routes/template/asides/barcode.vue"
export default component.exports